import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { ThemeToggle } from "@/components/common/ThemeToggle";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { label: "How It Works", href: "#how" },
  { label: "Features", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
  { label: "For Teams", href: "#pricing" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dest = user ? (user.role === "super_admin" ? "/superadmin" : "/app") : "/login";

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "glass-cream py-3 shadow-sm" : "py-5 bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <Logo light />
        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.replace(/\s/g, "-").toLowerCase()}`}
              className="text-sm text-ink/70 hover:text-maroon transition-colors">{l.label}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <ThemeToggle />
          <Link to={dest} data-testid="nav-signin" className="text-sm text-ink hover:text-maroon transition-colors px-4 py-2">
            {user ? "Dashboard" : "Sign in"}
          </Link>
          <button data-testid="nav-get-started" onClick={() => navigate("/register")}
            className="text-sm font-medium bg-maroon text-cream rounded-full px-5 py-2.5 hover:bg-maroon-dark transition-colors maroon-glow">
            Get Started
          </button>
        </div>
        <button data-testid="nav-mobile-toggle" className="lg:hidden text-maroon p-2" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden glass-cream mt-3 mx-4 rounded-2xl p-5 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-sm text-ink/70 hover:text-maroon">{l.label}</a>
          ))}
          <div className="h-px bg-maroon/10" />
          <Link to={dest} className="text-sm text-ink">{user ? "Dashboard" : "Sign in"}</Link>
          <button onClick={() => navigate("/register")} className="text-sm font-medium bg-maroon text-cream rounded-full px-5 py-2.5">Get Started</button>
        </div>
      )}
    </header>
  );
}
